import "../../assets/style/admin.css";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ErrorPage from "../ErrorPage";
import useIsAdmin from "../../hooks/useIsAdmin";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingContent from "../../components/LoadingContent";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";

import { Outlet } from "react-router-dom";
import { AdminLayoutContext } from "./AdminLayoutContext";

const AdminLayout = () => {
  document.title = "LVF1 - Admin";
  const { typeUser } = useIsAdmin();

  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("");
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);
  const toggleMenu = (menu: string) =>
    setActiveMenu((prev) => (prev === menu ? "" : menu));
  const [activeSubItem, setActiveSubItem] = useState("");
  const [menuVisible, setMenuVisible] = useState(
    () => window.innerWidth >= 1520,
  );

  const toggleMenuVisibility = () => {
    setMenuVisible(!menuVisible);
  };
  const toggleSubmenu = (submenu: string) =>
    setActiveSubmenu((prev) => (prev === submenu ? null : submenu));

  const handleNavigate = (path: string) => {
    setActiveSubItem(path);
    navigate(path);
    setMenuVisible(window.innerWidth >= 1520);
  };

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/data`,
      )
      .then(({ data }) => {
        setData(data);
      })
      .catch(({ response }) => {
        console.log(response);
      });
  }, []);

  if (data == null) return <LoadingContent />;
  if (typeUser < 2) return <ErrorPage />;

  return (
    <AdminLayoutContext.Provider value={{ setActiveMenu, setActiveSubItem }}>
      <div className="full-height app-container page-transition flex">
        <button
          className={`menu-toggle btn btn-outline-primary ${
            menuVisible ? "hasMenu" : "noMenu"
          }`}
          onClick={toggleMenuVisibility}
        >
          ☰
        </button>
        <aside className={`sidebar ${menuVisible ? "show" : "hide"} `}>
          <div id="admin-menu">
            <h4
              className="mb-4 text-center pointer"
              onClick={() => {
                navigate("/Admin");
                toggleMenu("");
              }}
            >
              Admin Panel
            </h4>

            {(typeUser === 2 || typeUser === 3 || typeUser === 5) && (
              <div className="menu-item">
                <div
                  onClick={() => toggleMenu("gp")}
                  className={`menu-title ${
                    activeMenu === "gp" ? "selected" : ""
                  }`}
                >
                  🏁 GP
                </div>
                {activeMenu === "gp" && (
                  <div className="submenu ps-3">
                    {typeUser == 2 ? (
                      <>
                        <div
                          onClick={() => handleNavigate("/Admin/UploadGP")}
                          className={
                            activeSubItem === "/Admin/UploadGP"
                              ? "selected"
                              : ""
                          }
                        >
                          Upload GP
                        </div>
                        <div
                          onClick={() =>
                            handleNavigate("/Admin/UpdateGPResults")
                          }
                          className={
                            activeSubItem === "/Admin/UpdateGPResults"
                              ? "selected"
                              : ""
                          }
                        >
                          Update GP Results
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {[2, 3].includes(typeUser) ? (
                      <div
                        onClick={() => handleNavigate("/Admin/PostPenaltiesGP")}
                        className={
                          activeSubItem === "/Admin/PostPenaltiesGP"
                            ? "selected"
                            : ""
                        }
                      >
                        Post Penalties
                      </div>
                    ) : (
                      <></>
                    )}
                    {typeUser == 2 ? (
                      <>
                        <div
                          onClick={() => handleNavigate("/Admin/UpdateGP")}
                          className={
                            activeSubItem === "/Admin/UpdateGP"
                              ? "selected"
                              : ""
                          }
                        >
                          Update GP
                        </div>
                        {/*<div
                          onClick={() =>
                            handleNavigate("/Admin/LivetimingRaceHC")
                          }
                          className={
                            activeSubItem === "/Admin/LivetimingRaceHC"
                              ? "selected"
                              : ""
                          }
                        >
                          Livetiming Race HC
                        </div>*/}
                        <div onClick={() => toggleSubmenu("generateXML")}>
                          Generate XML HC File
                        </div>
                        {activeSubmenu === "generateXML" && (
                          <div className="sub-submenu ps-3">
                            <div
                              onClick={() =>
                                handleNavigate("/Admin/GenerateXMLHCFile")
                              }
                              className={
                                activeSubItem === "/Admin/GenerateXMLHCFile"
                                  ? "selected"
                                  : ""
                              }
                            >
                              Assetto
                            </div>
                            <div
                              onClick={() =>
                                handleNavigate("/Admin/GenerateXMLHCFileRBR")
                              }
                              className={
                                activeSubItem === "/Admin/GenerateXMLHCFileRBR"
                                  ? "selected"
                                  : ""
                              }
                            >
                              RBR
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {[2, 5].includes(typeUser) ? (
                      <div
                        onClick={() => handleNavigate("/Admin/ReplaysRBR")}
                        className={
                          activeSubItem === "/Admin/ReplaysRBR"
                            ? "selected"
                            : ""
                        }
                      >
                        Replays RBR
                      </div>
                    ) : (
                      <></>
                    )}
                    <div
                      onClick={() => handleNavigate("/Admin/UpdateMilestones")}
                      className={
                        activeSubItem === "/Admin/UpdateMilestones"
                          ? "selected"
                          : ""
                      }
                    >
                      Update Milestones
                    </div>
                  </div>
                )}
              </div>
            )}
            {typeUser === 2 && (
              <>
                <div className="menu-item">
                  <div
                    onClick={() => toggleMenu("drivers")}
                    className={`menu-title ${
                      activeMenu === "drivers" ? "selected" : ""
                    }`}
                  >
                    🧑Drivers
                  </div>
                  {activeMenu === "drivers" && (
                    <div className="submenu ps-3">
                      <div
                        onClick={() => handleNavigate("/Admin/UpdateDriver")}
                        className={
                          activeSubItem === "/Admin/UpdateDriver"
                            ? "selected"
                            : ""
                        }
                      >
                        Update Driver
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/TitularDrivers")}
                        className={
                          activeSubItem === "/Admin/TitularDrivers"
                            ? "selected"
                            : ""
                        }
                      >
                        Titular Drivers
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/DriverCorrelations")
                        }
                        className={
                          activeSubItem === "/Admin/DriverCorrelations"
                            ? "selected"
                            : ""
                        }
                      >
                        Driver Correlations
                      </div>
                      <div onClick={() => toggleSubmenu("addassignment")}>
                        Add Assignment
                      </div>
                      {activeSubmenu === "addassignment" && (
                        <div className="sub-submenu ps-3">
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/AddAssignment")
                            }
                            className={
                              activeSubItem === "/Admin/AddAssignment"
                                ? "selected"
                                : ""
                            }
                          >
                            With Teams
                          </div>
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/AddAssignmentNoTeam")
                            }
                            className={
                              activeSubItem === "/Admin/AddAssignmentNoTeam"
                                ? "selected"
                                : ""
                            }
                          >
                            No Team DDBB
                          </div>
                        </div>
                      )}
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/RemoveAssignment")
                        }
                        className={
                          activeSubItem === "/Admin/RemoveAssignment"
                            ? "selected"
                            : ""
                        }
                      >
                        Remove Assignment
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/DriverPhoto")}
                        className={
                          activeSubItem === "/Admin/DriverPhoto"
                            ? "selected"
                            : ""
                        }
                      >
                        Driver Photos
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/ChangeLivetimingUsername")
                        }
                        className={
                          activeSubItem === "/Admin/ChangeLivetimingUsername"
                            ? "selected"
                            : ""
                        }
                      >
                        Change Livetiming Username
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/UploadCarImage")}
                        className={
                          activeSubItem === "/Admin/UploadCarImage"
                            ? "selected"
                            : ""
                        }
                      >
                        Upload Car Image
                      </div>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <div
                    onClick={() => toggleMenu("teams")}
                    className={`menu-title ${
                      activeMenu === "teams" ? "selected" : ""
                    }`}
                  >
                    👥 Teams
                  </div>
                  {activeMenu === "teams" && (
                    <div className="submenu ps-3">
                      <div
                        onClick={() => handleNavigate("/Admin/CreateTeam")}
                        className={
                          activeSubItem === "/Admin/CreateTeam"
                            ? "selected"
                            : ""
                        }
                      >
                        Create Team
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/UpdateTeam")}
                        className={
                          activeSubItem === "/Admin/UpdateTeam"
                            ? "selected"
                            : ""
                        }
                      >
                        Update Team
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/TeamCorrelations")
                        }
                        className={
                          activeSubItem === "/Admin/TeamCorrelations"
                            ? "selected"
                            : ""
                        }
                      >
                        Team Correlations
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/ChangeDriverTeam")
                        }
                        className={
                          activeSubItem === "/Admin/ChangeDriverTeam"
                            ? "selected"
                            : ""
                        }
                      >
                        Change Team Driver (Standings)
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/AddTeamChampionship")
                        }
                        className={
                          activeSubItem === "/Admin/AddTeamChampionship"
                            ? "selected"
                            : ""
                        }
                      >
                        Add Team Championship
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/DeleteTeamChampionship")
                        }
                        className={
                          activeSubItem === "/Admin/DeleteTeamChampionship"
                            ? "selected"
                            : ""
                        }
                      >
                        Delete Team Championship
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/CreateClass")}
                        className={
                          activeSubItem === "/Admin/CreateClass"
                            ? "selected"
                            : ""
                        }
                      >
                        Create Class
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/UploadTeamGeneralLogo")
                        }
                        className={
                          activeSubItem === "/Admin/UploadTeamGeneralLogo"
                            ? "selected"
                            : ""
                        }
                      >
                        Upload Team General Logo
                      </div>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <div
                    onClick={() => toggleMenu("champ")}
                    className={`menu-title ${
                      activeMenu === "champ" ? "selected" : ""
                    }`}
                  >
                    🏆Championship
                  </div>
                  {activeMenu === "champ" && (
                    <div className="submenu ps-3">
                      <div
                        onClick={() => handleNavigate("/Admin/AddChampionship")}
                        className={
                          activeSubItem === "/Admin/AddChampionship"
                            ? "selected"
                            : ""
                        }
                      >
                        Add Championship
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/RemoveChampionship")
                        }
                        className={
                          activeSubItem === "/Admin/RemoveChampionship"
                            ? "selected"
                            : ""
                        }
                      >
                        Remove Championship
                      </div>
                      <div onClick={() => toggleSubmenu("scorings")}>
                        Scorings
                      </div>
                      {activeSubmenu === "scorings" && (
                        <div className="sub-submenu ps-3">
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/CreateScoringVariant")
                            }
                            className={
                              activeSubItem === "/Admin/CreateScoringVariant"
                                ? "selected"
                                : ""
                            }
                          >
                            Create Scoring Variant
                          </div>
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/CreateCustomScoringName")
                            }
                            className={
                              activeSubItem === "/Admin/CreateCustomScoringName"
                                ? "selected"
                                : ""
                            }
                          >
                            Create Custom Scoring Name
                          </div>
                        </div>
                      )}
                      <div onClick={() => toggleSubmenu("custom")}>
                        Colors/Logos Custom
                      </div>
                      {activeSubmenu === "custom" && (
                        <div className="sub-submenu ps-3">
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/No-OfficialLogos")
                            }
                            className={
                              activeSubItem === "/Admin/No-OfficialLogos"
                                ? "selected"
                                : ""
                            }
                          >
                            No-Official Logos
                          </div>
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/No-OfficialColors")
                            }
                            className={
                              activeSubItem === "/Admin/No-OfficialColors"
                                ? "selected"
                                : ""
                            }
                          >
                            No-Official Colors
                          </div>
                        </div>
                      )}
                      <div
                        onClick={() => handleNavigate("/Admin/SkipShift")}
                        className={
                          activeSubItem === "/Admin/SkipShift" ? "selected" : ""
                        }
                      >
                        Skip Shifts
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/DQDriver")}
                        className={
                          activeSubItem === "/Admin/DQDriver" ? "selected" : ""
                        }
                      >
                        DQ Driver
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/ModifyResult")}
                        className={
                          activeSubItem === "/Admin/ModifyResult"
                            ? "selected"
                            : ""
                        }
                      >
                        Modify Race Result
                      </div>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <div
                    onClick={() => toggleMenu("circuits")}
                    className={`menu-title ${
                      activeMenu === "circuits" ? "selected" : ""
                    }`}
                  >
                    🏎️ Circuits
                  </div>
                  {activeMenu === "circuits" && (
                    <div className="submenu ps-3">
                      <div
                        onClick={() => handleNavigate("/Admin/CreateCircuit")}
                        className={
                          activeSubItem === "/Admin/CreateCircuit"
                            ? "selected"
                            : ""
                        }
                      >
                        Create Circuit
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/UpdateCircuit")}
                        className={
                          activeSubItem === "/Admin/UpdateCircuit"
                            ? "selected"
                            : ""
                        }
                      >
                        Update Circuit
                      </div>

                      <div
                        onClick={() =>
                          handleNavigate("/Admin/AssignRallyCircuits")
                        }
                        className={
                          activeSubItem === "/Admin/AssignRallyCircuits"
                            ? "selected"
                            : ""
                        }
                      >
                        Assign Rally Circuits
                      </div>
                      <div onClick={() => toggleSubmenu("generateAIW")}>
                        Generate AIW
                      </div>
                      {activeSubmenu === "generateAIW" && (
                        <div className="sub-submenu ps-3">
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/CreateAIWFromImage")
                            }
                            className={
                              activeSubItem === "/Admin/CreateAIWFromImage"
                                ? "selected"
                                : ""
                            }
                          >
                            Create AIW From Image
                          </div>
                          <div
                            onClick={() =>
                              handleNavigate("/Admin/CreateAIWFromRBR")
                            }
                            className={
                              activeSubItem === "/Admin/CreateAIWFromRBR"
                                ? "selected"
                                : ""
                            }
                          >
                            Create AIW From RBR
                          </div>
                          <div className="disabled-btn">
                            {`Create AIW From AC [from LiveTiming -> Record AIW]`}
                          </div>
                          <div className="disabled-btn">
                            {`Create AIW From RF2 [from Update Circuit -> Select AIW from MAS]`}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <div
                    onClick={() => toggleMenu("gral")}
                    className={`menu-title ${
                      activeMenu === "gral" ? "selected" : ""
                    }`}
                  >
                    ⚙️ General
                  </div>
                  {activeMenu === "gral" && (
                    <div className="submenu ps-3">
                      <div
                        onClick={() => handleNavigate("/Admin/CreateFlag")}
                        className={
                          activeSubItem === "/Admin/CreateFlag"
                            ? "selected"
                            : ""
                        }
                      >
                        Create Flag
                      </div>

                      <div
                        onClick={() => handleNavigate("/Admin/CreateGame")}
                        className={
                          activeSubItem === "/Admin/CreateGame"
                            ? "selected"
                            : ""
                        }
                      >
                        Create Game
                      </div>

                      <div
                        onClick={() =>
                          handleNavigate("/Admin/UpdateRegulation")
                        }
                        className={
                          activeSubItem === "/Admin/UpdateRegulation"
                            ? "selected"
                            : ""
                        }
                      >
                        Update Regulation
                      </div>

                      <div
                        onClick={() => handleNavigate("/Admin/Config")}
                        className={
                          activeSubItem === "/Admin/Config" ? "selected" : ""
                        }
                      >
                        Config
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/UpdateIndexPhotos")
                        }
                        className={
                          activeSubItem === "/Admin/UpdateIndexPhotos"
                            ? "selected"
                            : ""
                        }
                      >
                        Update Index Photos
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/ScriptCameraRace")
                        }
                        className={
                          activeSubItem === "/Admin/ScriptCameraRace"
                            ? "selected"
                            : ""
                        }
                      >
                        Script Camera Race
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/Donors")}
                        className={
                          activeSubItem === "/Admin/Donors" ? "selected" : ""
                        }
                      >
                        Donors
                      </div>
                      <div
                        onClick={() => handleNavigate("/Admin/Charges")}
                        className={
                          activeSubItem === "/Admin/Charges" ? "selected" : ""
                        }
                      >
                        Charges
                      </div>
                    </div>
                  )}
                </div>
                <div className="menu-item">
                  <div
                    onClick={() => toggleMenu("social")}
                    className={`menu-title ${
                      activeMenu === "social" ? "selected" : ""
                    }`}
                  >
                    📢 Social Media
                  </div>
                  {activeMenu === "social" && (
                    <div className="submenu ps-3">
                      <div
                        onClick={() =>
                          handleNavigate(
                            "/Admin/SocialMedia/EditDiscordMessage",
                          )
                        }
                        className={
                          activeSubItem ===
                          "/Admin/SocialMedia/EditDiscordMessage"
                            ? "selected"
                            : ""
                        }
                      >
                        Edit Discord Message
                      </div>
                      <div
                        onClick={() =>
                          handleNavigate("/Admin/SocialMedia/UploadReel")
                        }
                        className={
                          activeSubItem === "/Admin/SocialMedia/UploadReel"
                            ? "selected"
                            : ""
                        }
                      >
                        Upload Reel
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
            {(typeUser === 2 || typeUser === 4) && (
              <div className="menu-item">
                <div
                  onClick={() => toggleMenu("reports")}
                  className={`menu-title ${
                    activeMenu === "reports" ? "selected" : ""
                  }`}
                >
                  📰 News
                </div>
                {activeMenu === "reports" && (
                  <div className="submenu ps-3">
                    <div
                      onClick={() => handleNavigate("/Admin/CreateNew")}
                      className={
                        activeSubItem === "/Admin/CreateNew" ? "selected" : ""
                      }
                    >
                      Create News
                    </div>

                    <div
                      onClick={() => handleNavigate("/Admin/UpdateNews")}
                      className={
                        activeSubItem === "/Admin/UpdateNews" ? "selected" : ""
                      }
                    >
                      Update News
                    </div>
                    <div
                      onClick={() => handleNavigate("/Admin/PreGPGenerator")}
                      className={
                        activeSubItem === "/Admin/PreGPGenerator"
                          ? "selected"
                          : ""
                      }
                    >
                      Pre GP Generator
                    </div>
                    <div
                      onClick={() =>
                        handleNavigate("/Admin/PreGPRallyGenerator")
                      }
                      className={
                        activeSubItem === "/Admin/PreGPRallyGenerator"
                          ? "selected"
                          : ""
                      }
                    >
                      Pre GP Rally Generator
                    </div>
                    <div
                      onClick={() => handleNavigate("/Admin/GPGenerator")}
                      className={
                        activeSubItem === "/Admin/GPGenerator" ? "selected" : ""
                      }
                    >
                      GP Generator
                    </div>
                    <div
                      onClick={() => handleNavigate("/Admin/GPRallyGenerator")}
                      className={
                        activeSubItem === "/Admin/GPRallyGenerator"
                          ? "selected"
                          : ""
                      }
                    >
                      GP Rally Generator
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </aside>
        <main>
          <Outlet />
        </main>
      </div>
    </AdminLayoutContext.Provider>
  );
};

export default AdminLayout;
